const state = {
  segment: null,
  loggedIn: null
};

const getters = {
  isUserPremium: state => {
    return state.segment === "premium";
  },
  isUserBasic: state => {
    return state.segment === "basic";
  },
  isUserLoggedOut: state => {
    return state.loggedIn === false;
  },
  isUserLoggedIn: state => {
    return state.loggedIn === true;
  }
};

const mutations = {
  segment: (state, payload) => {
    state.segment = payload;
  },
  loggedIn: (state, payload) => {
    state.loggedIn = payload;
  }
};

const actions = {
  setup: ({ commit }, payload) => {
    commit("segment", payload.segment);
    commit("loggedIn", !payload.guest);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
